import * as React from 'react';
import { TextDirection } from './textDirection';
import { useSelector } from 'react-redux';
import { AppState } from '../core/redux/appState';
import { strictEquals } from '../language/module';


interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  innerHtml: string;
  forceDirection?: TextDirection;
}


/**
 * LocalHTML: a div component that, like the LocalDiv, exposes all the properties of a normal div but renders text
 * according to the user's locale-specific text direction.
 *
 * Unlike LocalDiv, this component wraps an entire locale-specific HTML block, as many locale strings are stored in the
 * database as such.
 *
 * PureComponent: true
 * Redux Connected: true
 */
const LocalHTMLContainer: React.FC<Props> = props => {
  // React complains if you forward unknown props to HTML elements *eye-roll*
  const { innerHtml, forceDirection, ...rest } = props;

  const layoutDirection = useSelector<AppState, TextDirection>(
    state => state.locale.textDirection,
    strictEquals,
  );

  return (
    <div
      {...rest}
      dir={forceDirection ?? layoutDirection}
      dangerouslySetInnerHTML={{ __html: innerHtml }}
    />
  );
};

export default LocalHTMLContainer;
